module.exports = __webpack_public_path__ + "static/img/bg.1909265e.jpg";